export const FETCH_APPLIED_JOB_DETAIL_REQUEST = 'FETCH_APPLIED_JOB_DETAIL_REQUEST'
export const FETCH_APPLIED_JOB_DETAIL_SUCCESS = 'FETCH_APPLIED_JOB_DETAIL_SUCCESS'
export const FETCH_APPLIED_JOB_DETAIL_FAILED = 'FETCH_APPLIED_JOB_DETAIL_FAILED'
